
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TheHorizontalScan',
  props: {
    crosshair: Object,
  },
})
